<template>
  <div>
    <el-button class="mt-10 mb-10" @click="add()">添加</el-button>
    <el-table
        :data="list"
    >
      <el-table-column label="分支轴">
        <template v-slot="{ row, $index }">
          <el-select v-model="row.metric" clearable size="small">
            <el-option v-for="(item, index) in metricOption"
                       :key="index"
                       :label="item.name" :value="item.value"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="最小数值">
        <template v-slot="{ row, $index }">
          <el-input-number size="small" v-model="row.min"/>
        </template>
      </el-table-column>
      <el-table-column label="最大数值">
        <template v-slot="{ row, $index }">
          <el-input-number size="small" v-model="row.max"/>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80">
        <template v-slot="{ row, $index }">
          <el-link type="primary" @click="list.splice($index,1)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script setup>
import {ref} from "vue";
import {cloneDeep} from "lodash-es";

const props = defineProps({
  main: {}
})
const list = ref([])
if (props.main.activeOption.axisCustomSet) {
  list.value = cloneDeep(props.main.activeOption.axisCustomSet)
}

const metricOption = computed(() => {
  let ref = props?.main?.$refs?.container?.getItemRef()
  let v = ref?.dataChart || [];
  return v.map(item => {
    return {
      name: item[ref.dcode],
      value: item[ref.dcode],
    }
  })
})

function add() {
  list.value.push({})
}

defineExpose({
  getSetting() {
    return list.value
  }
})
</script>
<style lang="scss">

</style>